import v from '@/main'
function fromatTimestamp(ts){
  let date = new Date(ts*1000);
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  let D = date.getDate();
  // h = date.getHours() + ':';
  // m = date.getMinutes() + ':';
  // s = date.getSeconds(); 
  return Y+M+D
  // console.log(Y+M+D+h+m+s); 
}
function formatDate(date) {  
  var y = date.getFullYear();  
  var m = date.getMonth() + 1;  
  m = m < 10 ? '0' + m : m;  
  var d = date.getDate();  
  d = d < 10 ? ('0' + d) : d;  
  return y + '-' + m + '-' + d;  
}

function setCookie(cname, cvalue, exmins) {
  let d = new Date();
  d.setTime(d.getTime() + (exmins*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname){
  let strcookie = document.cookie;
  let arrcookie = strcookie.split("; ");
  for ( let i = 0; i < arrcookie.length; i++) {
    let arr = arrcookie[i].split("=");
    if (arr[0] == cname){
      return arr[1];
    }
  }
  return "";
}

function delCookie(cname) {     
  setCookie(cname, "", -1); 
}

function getQueryString( name ){
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
      return decodeURIComponent(r[2])
  }
  return null
}

function getShareConfig(shareContent,v){
  v.axios({
    method: 'GET',
    url:`/wechat/js-sdk?from=${v.base64.encode(window.location.href)}`,
    headers: {
      'Authorization': `Bearer ${getCookie('token')}` 
    },
  }).then( (res) => {
    if(res.data.code == 0){
      wxset(res.data.data.config ,shareContent)
    }else{
      console.log(res.data.message)
    }
  })
}
function wxset(config, shareContent){
  v.wx.config(config);
  v.wx.ready( () => { 
    v.wx.onMenuShareAppMessage({ 
      title: shareContent.title, 
      desc: shareContent.desc,
      link: location.href, //.split('?')[0]
      imgUrl: nowurl+'/share-logo.png', 
      success() {
        // 设置成功
      }
    }); 
    v.wx.onMenuShareTimeline({ 
      title: shareContent.title,
      desc: shareContent.desc, 
      link: location.href.split('?')[0],
      imgUrl: nowurl+'/share-logo.png', 
      success() {
        // 设置成功
      }
    });
  })
}
function throttle(fn,wait){
  var timer = null;
  return function(){
    var context = this;
    var args = arguments;
    if(!timer){
        timer = setTimeout(function(){
            fn.apply(context,args);
            timer = null;
        },wait)
    }
  }
}
var nowurl = 'https://vip.jinlibx.com'
var appid = 'wx39e54711a30945e2'
export default {
  fromatTimestamp,
  formatDate,
  setCookie,
  getCookie,
  delCookie,
  getQueryString,
  getShareConfig,
  nowurl,
  appid,
  throttle
}